/**
 * Opens a confirmation modal with cancel and confirm actions.
 * Handles show, close, backdrop click, and listener cleanup.
 * @param {Object} opts
 * @param {HTMLElement} opts.modal - The modal overlay element
 * @param {HTMLElement | null} opts.cancelEl - Cancel button (optional)
 * @param {HTMLElement} opts.confirmEl - Confirm button
 * @param {() => Promise<void>} opts.onConfirm - Async action when confirm is clicked
 * @param {() => void} [opts.onCancel] - Called when cancel or backdrop is used
 * @param {string} [opts.errorMessage] - Message shown when onConfirm throws (default: 'Une erreur est survenue.')
 */
export function openConfirmModal({ modal, cancelEl, confirmEl, onConfirm, onCancel, errorMessage = 'Une erreur est survenue.' }) {
	if (!modal || !confirmEl) return;

	modal.classList.add('show');

	function close() {
		modal.classList.remove('show');
		if (cancelEl) cancelEl.removeEventListener('click', cancelHandler);
		confirmEl.removeEventListener('click', confirmHandler);
		modal.removeEventListener('click', modalClickHandler);
	}

	const cancelHandler = () => {
		close();
		onCancel?.();
	};

	const confirmHandler = async () => {
		try {
			await onConfirm();
			close();
		} catch (err) {
			console.error(err);
			alert(errorMessage);
			close();
		}
	};

	const modalClickHandler = (ev) => {
		if (ev.target === modal) cancelHandler();
	};

	if (cancelEl) cancelEl.addEventListener('click', cancelHandler);
	confirmEl.addEventListener('click', confirmHandler);
	modal.addEventListener('click', modalClickHandler);
}
